export default [
  "apc",
  "are",
  "arg",
  "aus",
  "aut",
  "bel",
  "bgd",
  "bra",
  "can",
  "che",
  "chl",
  "chn",
  "col",
  "cze",
  "deu",
  "dnk",
  "eca",
  "egy",
  "esp",
  "eue",
  "fin",
  "fra",
  "gbr",
  "gch",
  "hkg",
  "idn",
  "ind",
  "irl",
  "isr",
  "ita",
  "jpn",
  "kor",
  "lac",
  "mex",
  "mna",
  "mys",
  "nac",
  "nga",
  "nld",
  "nor",
  "nzl",
  "pak",
  "phl",
  "pol",
  "prt",
  "rou",
  "rus",
  "sau",
  "sgp",
  "ssa",
  "swe",
  "tha",
  "tur",
  "usa",
  "vnm",
  "zaf",
] as const;
